import { jsx } from 'react/jsx-runtime';
import { HoverPopover } from '@flex-design-system/fx';
import { css } from '@flex-design-system/stitches-react';
import { useControllableState } from '@flexteam/hooks-common';
import { useState } from 'react';
import UserMiniProfile from './Content.mjs';
import { useMiniProfileHoverPopoverContext, MiniProfileHoverPopoverProvider } from './context.mjs';
import '@flex-design-system/ve-presets/styles.css';
import '@flex-design-system/fx/base.css';
import '@flex-design-system/fx/styles.vanilla.css';

function Content({ userIdHash, ...props }) {
  const [isLoading, setIsLoading] = useState(true);
  const { setOpen } = useMiniProfileHoverPopoverContext(
    "MiniProfileHoverPopover.Content"
  );
  return /* @__PURE__ */ jsx(
    HoverPopover.Content,
    {
      ...props,
      onClick: (e) => {
        e.stopPropagation();
      },
      sideOffset: 4,
      css: void 0,
      className: contentStyle({ isLoading }),
      children: /* @__PURE__ */ jsx(
        UserMiniProfile,
        {
          userIdHash,
          onContentLoaded: () => setIsLoading(false),
          onNavigateToUserProfile: () => setOpen(false)
        }
      )
    }
  );
}
const contentStyle = css({
  width: 320,
  variant: {
    /**
     * NOTE: user정보 로드전에 content의 boxShadow가 먼저보이는것 방지
     * component mount/unmount로 컨트롤하면 popover자체가 그려지지 않음
     */
    isLoading: {
      true: {
        boxShadow: "none"
      }
    }
  }
});
function Root({
  closeDelay = 200,
  openDelay = 300,
  open: openFromProps,
  onOpenChange: onOpenChangeFromProps,
  ...props
}) {
  const [open, setOpen] = useControllableState({
    prop: openFromProps,
    onChange: onOpenChangeFromProps
  });
  return /* @__PURE__ */ jsx(MiniProfileHoverPopoverProvider, { setOpen, children: /* @__PURE__ */ jsx(
    HoverPopover,
    {
      closeDelay,
      openDelay,
      open,
      onOpenChange: setOpen,
      ...props
    }
  ) });
}
const MiniProfileHoverPopover = {
  Root,
  Content,
  Trigger: HoverPopover.Trigger
};

export { MiniProfileHoverPopover };
//# sourceMappingURL=MiniProfileHoverPopover.mjs.map
